import { Chip, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import {
  gettransferStudentList,
  transferStudent,
} from "./../../services/transferStudent";
import CustomNoRowsOverlay from "../../../../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import TransferIcon from "../../../../../../newComponent/iconsComp/TransferIcon";
import { fDate } from "../../../../../../../utils/formatTime";
import CustomPopup from "../../../../../../../components/CustomPopup";
import TransferStudentForm from "./TransferStudentForm";
import { fi } from "date-fns/locale";
import MainCard from "../../../../../../../components/Maincard";
import SearchTextFieldComp from "../../../../../../newComponent/newtextfieldComp/SearchTextFieldComp";
import LoaderComp from "../../../../../../newComponent/LoaderComp/Loader";

export default function TransferStudentList() {
  const userId = localStorage.getItem("userId");
  const [transferStudentList, setTransferStudentList] = useState([]);
  const [openTransferDialog, setOpenTransferDialog] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);

  // fetch student list
  useEffect(() => {
    const requestData = {
      user_id: parseInt(userId),
    };

    setIsLoading(true);
    const fetchStdentList = async () => {
      try {
        const response = await gettransferStudentList(requestData);
        if (response.status === 200) {
          setTransferStudentList(response.data);
          setSearchData(response.data);
          setIsLoading(false);
        } else {
          setTransferStudentList([]);
          setSearchData([]);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error fetching trainers:", error);
        setTransferStudentList([]);
        setSearchData([]);
        setIsLoading(false);
      }
    };

    fetchStdentList();
  }, [userId]);

  // function to open transfer dialog

  const handleOpenTransferDialog = (rowData) => {
    setOpenTransferDialog(true);
    setSelectedRowData(rowData);
  };

  // function to close transfer dialog

  const handleCloseTransferDialog = () => {
    setOpenTransferDialog(false);
  };

  // function to transfer student
  const columns = [
    {
      field: "action",
      headerName: "Action",
      //width: 70,
        flex:1,
      minWidth: 70,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <TransferIcon
            color="#00b13f"
            fontSize="1rem"
            tooltipTitle="Transfer"
            onClick={() => handleOpenTransferDialog(params.row)}
          />
        </div>
      ),
    },
    {
      field: "studentName",
      headerName: "Student Name",
      //width: 200,
        flex:1,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography sx={{color:"#46B1FF",cursor:"pointer"}} onClick={()=>window.open(`/enquirydetails/${params.row?.enquiry_id?.id}`,"_blank")}>{`${params.row.enquiry_id?.first_name || ""} ${params.row.enquiry_id?.last_name || ""}`}</Typography>
      ),
    },

    {
      field: "enrollmentDate",
      headerName: "Enrollment Date",
      //width: 150,
        flex:1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography>{fDate(params.row?.enrollment_date)}</Typography>
      ), // fDate(params.row?.enrollment_date),
    },
    {
      field: "class_name",
      headerName: "Class Name",
      //width: 200,
      flex:1,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography>{params.row?.class_id?.name}</Typography>
      ), // params.row.class_id?.name,
    },
    {
      field: "package_duration",
      headerName: "Package Duration",
      //width: 200,
        flex:1,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography>{params.row?.package_id?.duration} Days</Typography>
      ),
    },
    {
      field: "trainer_name",
      headerName: "Trainer Name",
      //width: 150,
        flex:1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography>
          {params.row?.class_id?.trainer_id?.first_name}{" "}
          {params.row?.class_id?.trainer_id?.last_name}
        </Typography>
      ),
    },
    {
      field: "enrolled_branch",
      headerName: "Enrolled Branch",
      //width: 150,
        flex:1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography>{params.row.branch_id?.branch_name}</Typography>
      ), // params.row.branch_id?.branch_name,
    },

    {
      field: "enrolled_by",
      headerName: "Enrolled By",
      //width: 150,
        flex:1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography>
          {params.row.created_by?.first_name} {params.row.created_by?.last_name}
        </Typography>
      ),
    },
    {
      field: "testType",
      headerName: "Test Type",
      //width: 150,
        flex:1,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Typography>{params.row?.test_type_id?.name}</Typography>
      ), // params.row?.test_type_id?.name,
    },

    {
      field: "status",
      headerName: "Status",
      //width: 100,
        flex:1,
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Chip
          label={params.row.status_of_student}
          size="small"
          variant="contained"
          color={
            params.row.status_of_student === "active" ? "secondary" : "error"
          }
        />
      ),
    },
  ];

  //   Search All column data
  const handlenamefilter = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)
    let filteredData1 = searchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.enquiry_id?.first_name || ""} ${data?.enquiry_id?.last_name || ""}`,
        `${fDate(data?.enrollment_date) || ""}`,
        `${data?.class_id?.name || ""}`,
        `${data?.branch_id?.branch_name || ""}`,
        `${data?.status_of_student || ""}`,
        `${data?.created_by?.first_name || ""} ${data?.created_by?.last_name || ""}`,
        `${data?.package_id?.duration || ""} Days`,
        `${data?.test_type_id?.name || ""}`,
        `${data?.class_id?.trainer_id?.first_name || ""} ${data?.class_id?.trainer_id?.last_name || ""}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value),
      );
    });

    setTransferStudentList(filteredData1);
  };

  return (
    <>
      <LoaderComp isLoading={isLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign="right">
                <SearchTextFieldComp
                  placeholder="search by student name..."
                  size="small"
                  onChange={handlenamefilter}
                />
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={transferStudentList}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomPopup
        open={openTransferDialog}
        onClose={handleCloseTransferDialog}
        title="Transfer Student"
        maxWidth="sm"
        showDivider={true}
        component={
          <TransferStudentForm
            onClose={handleCloseTransferDialog}
            selectedRowData={selectedRowData}
          />
        }
      />
    </>
  );
}
